import Launch from '@/views/Launch.vue'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/classic/Dashboard.vue'
import Module from '@/views/Module.vue'
import Maintenance from '@/views/Maintenance.vue'
import Tabs from '@/views/next-gen/Tabs.vue'
import WidgetPage from '@/views/WidgetPage.vue'

export const routes = [
    {
        path: '/',
        name: 'launch',
        component: Launch,
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/view/:id',
        name: 'view',
        component: Module,
        props: true,
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        component: Maintenance,
    },
    {
        path: '/next-gen/',
        name: 'next-gen',
        component: Tabs,
        children: [
            {
                path: '',
                redirect: { name: 'next-gen.spaces.me' },
            },
            {
                path: 'spaces',
                name: 'next-gen.spaces.me',
                component: () => import('@/views/next-gen/spaces/Space.vue'),
            },
            {
                path: 'spaces/:externalId',
                name: 'next-gen.spaces.show',
                component: () => import('@/views/next-gen/spaces/NestedSpace.vue'),
            },
            {
                path: 'events',
                name: 'next-gen.events',
                component: () => import('@/views/next-gen/Events.vue'),
            },
            {
                path: 'news',
                name: 'next-gen.news',
                component: () => import('@/views/next-gen/News.vue'),
            },
            {
                path: 'notifications',
                name: 'next-gen.notifications',
                component: () => import('@/views/next-gen/Notifications.vue'),
            },
            {
                path: 'more',
                name: 'next-gen.more',
                component: () => import('@/views/next-gen/More.vue'),
            },
        ],
    },
    {
        path: '/widgets/:widgetPageId',
        name: 'widgets.show',
        component: WidgetPage,
    },
]
